import * as React from 'react';
import { t } from '@deltasierra/shared';
import { Input } from '../../Input';
import { SelectedItemsList } from './SelectedItemsList';
import { AssetShareTarget } from './types';
import { AssetShareTargetCheckbox } from './AssetShareTargetCheckbox';

export type AssetClientShareListProps = {
    clients: ReadonlyArray<AssetShareTarget>;
    selected: ReadonlyArray<string>;
    disabled?: ReadonlyArray<string>;
    onChange: (selected: string[]) => void;
};

export const AssetClientShareList: React.FC<AssetClientShareListProps> = ({
    clients,
    disabled = [],
    onChange,
    selected,
}) => {
    const [searchTerm, setSearchTerm] = React.useState('');
    return (
        <div className="col-sm-10">
            <div style={{ float: 'left' }}>
                <div
                    className="well"
                    style={{
                        background: 'white',
                        height: 200,
                        overflowX: 'hidden',
                        overflowY: 'auto',
                        scrollbarWidth: 'none',
                        width: 200,
                    }}
                >
                    <Input
                        clearable
                        placeholder={`${t('COMMON.FILTER')}...`}
                        style={{ width: '100%' }}
                        onTermChange={setSearchTerm}
                    />
                    {clients
                        .filter(client => client.title.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()))
                        .map(client => (
                            <AssetShareTargetCheckbox
                                disabled={disabled}
                                item={client}
                                key={client.id}
                                selected={selected}
                                onChange={onChange}
                            />
                        ))}
                </div>
            </div>
            <SelectedItemsList
                items={clients.filter(client => selected.includes(client.id))}
                title={t('COMMON.SELECTED_CLIENTS')}
            />
        </div>
    );
};
AssetClientShareList.displayName = 'AssetClientShareList';
